import Page from '../../layout/Page'
import StatisticsPageContent from './StatisticsPageContent'

const StatisticsPage = () => <Page content={<StatisticsPageContent />} />

export default StatisticsPage
